import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';

export interface ErrorProps {
  className?: string;
  title?: string;
  description?: string;
  children?: ReactNode;
  icon?: ReactNode;
  noMarginTop?: boolean;
  descriptionMarginBottom?: number;
}

export const Error = ({
  className,
  title,
  description,
  children,
  icon,
  noMarginTop,
  descriptionMarginBottom,
}: ErrorProps) => (
  <StyledContainer className={className} noMarginTop={noMarginTop}>
    {icon && <StyledIcon>{icon}</StyledIcon>}
    <StyledTitle>{title}</StyledTitle>
    <StyledDescription descriptionMarginBottom={descriptionMarginBottom}>{description}</StyledDescription>
    <StyledChildrenWrapper>{children}</StyledChildrenWrapper>
  </StyledContainer>
);

const StyledContainer = styled.div<{ noMarginTop?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: ${({ noMarginTop }) => (noMarginTop ? '0' : '100px')};
  flex-grow: 1;
`;

const StyledTitle = styled.div`
  margin-bottom: 4px;
  ${Typography.XSmall};
  color: ${Color.Black};
  font-weight: ${FontWeight.Bold};
`;
const StyledIcon = styled.div`
  line-height: 0;
  margin-bottom: 16px;
`;
const StyledDescription = styled.div<{ descriptionMarginBottom?: number }>`
  ${Typography.XXSmall};
  font-weight: ${FontWeight.Regular};
  color: ${Color.Gray600};
  margin-bottom: ${({ descriptionMarginBottom }) => descriptionMarginBottom ?? 24}px;
  text-align: center;
  white-space: pre-line;
`;

const StyledChildrenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
